import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React from "react";
import Error from "../../../../components/alerts/error";
import Loader from "../../../../components/loader";
import RdsPartnerSelector from "../../../../components/rdsPartnerSelector";
import TimeZoneSelector from "../../../../components/timeZoneSelector";
import { updatePool } from "../../../../actions/poolAddEdit";
import PropTypes from "prop-types";
import { AsyncCreatable } from "react-select";
import PoolApi from "../../../../api/pools";

class PoolInfo extends React.Component {
  constructor(props) {
    super(props);
    this.submitPool = this.submitPool.bind(this);
    this.CancelEdit = this.CancelEdit.bind(this);
    this.EditPool = this.EditPool.bind(this);
    this.IsNameValid = this.IsNameValid.bind(this);
    this.state = {
      poolName: this.props.poolName,
      poolZone: this.props.poolZone,
      timeZone: this.props.timeZone || '',
      partnerSubscriptionId: this.props.partnerSubscriptionId || '',
      partnerId: this.props.partnerId || '',
      poolInfoEditMode: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.poolName !== this.props.poolName) {
      this.setState((state) => {
        return {
          ...state,
          poolName: this.props.poolName,
        };
      });
    }
    if (prevProps.partnerId !== this.props.partnerId) {
      this.setState((state) => {
        return {
          ...state,
          partnerId: this.props.partnerId || ''
        }
      })
    }

    if (prevProps.partnerSubscriptionId !== this.props.partnerSubscriptionId) {
      this.setState((state) => {
        return {
          ...state,
          partnerSubscriptionId: this.props.partnerSubscriptionId || "",
        };
      });
    }

    if (prevProps.timeZone !== this.props.timeZone) {
      this.setState((state) => {
        return {
          ...state,
          timeZone: this.props.timeZone || "",
        };
      });
    }

    if (prevProps.poolZone !== this.props.poolZone) {
      this.setState((state) => {
        return {
          ...state,
          poolZone: this.props.poolZone,
        };
      });
    }
  }

  submitPool() {
    this.props.updatePool({
      id: this.props.poolId,
      tenant: this.props.tenant,
      name: this.state.poolName,
      timeZone: this.state.timeZone,
      partnerSubscriptionId: this.state.partnerSubscriptionId,
      poolZone: this.state.poolZone,
    });
  }

  CancelEdit() {
    this.setState((state) => {
      return {
        ...state,
        poolName: this.props.poolName,
        poolZone: this.props.poolZone,
        timeZone: this.props.timeZone || "",
        partnerSubscriptionId: this.props.partnerSubscriptionId || "",
        poolInfoEditMode: false,
      };
    });
  }

  EditPool() {
    this.setState((state) => {
      return {
        ...state,
        timeZone: this.props.timeZone || this.props.timeZones[0],
        poolInfoEditMode: true,
      };
    });
  }

  IsInvalidForm() {
    return this.props.isSaving || this.state.poolName === "" || this.state.poolName === undefined
      || this.state.partnerSubscriptionId === undefined || this.state.partnerSubscriptionId === "" || this.state.partnerSubscriptionId === "0"
      || this.state.timeZone === "" || this.state.timeZone === undefined
  }

  IsNameValid() {
    return this.state.poolName !== undefined && this.state.poolName !== "";
  }

  getPoolZoneOptions(searchText) {
    return PoolApi.GetPoolZoneSuggestions(searchText)
      .then((response) => response.json())
      .then((response) => response.items.map((datum) => ({ label: datum.poolZone, value: datum.poolZone })));
  }

  render() {
    let actionMenu = null;

    if (this.state.poolInfoEditMode) {
      actionMenu = (
        <div className="float-right">
          <button id="btnCancel" onClick={() => this.CancelEdit()} className="btn btn-sm btn-secondary mr-1">
            Cancel
          </button>
          <button id="btnSave" disabled={this.IsInvalidForm()} onClick={() => this.submitPool()} className="btn btn-sm btn-success">
            Save
          </button>
        </div>
      );
    } else {
      actionMenu = (
        <div className="float-right">
          <button
            id="switchMode"
            className="btn btn-sm btn-primary"
            onClick={() => {
              this.EditPool();
            }}
          >
            Edit Info
          </button>
        </div>
      );
    }

    return (
      <div>
        <div className="row switchMode">
          <div className="col-lg-5 col-sm-12">
            <h3 className="pull-left"> Info</h3>
          </div>
          {actionMenu}
        </div>

        <form className="col-lg-4 col-md-8 col-sm-12">
          {this.props.isLoading || this.props.isSaving ? <Loader /> : null}
          {this.props.error !== undefined && this.props.error !== "" ? <Error title="" body={this.props.error} /> : null}

          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              id="name"
              placeholder="Name"
              required
              value={this.state.poolName}
              className={this.IsNameValid() ? "form-control" : "form-control is-invalid"}
              disabled={this.state.poolInfoEditMode === false ? "disabled" : ""}
              onChange={(event) => {
                let val = event.target.value;
                this.setState((state) => {
                  return {
                    ...state,
                    poolName: val,
                  };
                });
              }}
            />
          </div>
          <RdsPartnerSelector
            SelectedId={this.state.partnerSubscriptionId}
            disabled={this.state.poolInfoEditMode === false ? "disabled" : ""}
            onChange={(partnerSubscriptionId) => {
              this.setState((state) => {
                return { ...state, partnerSubscriptionId: partnerSubscriptionId };
              });
            }}
          />
          <TimeZoneSelector
            timeZone={this.state.timeZone}
            disabled={this.state.poolInfoEditMode === false ? "disabled" : ""}
            onChange={(timeZone) => {
              this.setState((state) => {
                return { ...state, timeZone: timeZone };
              });
            }}
          />
          <div className="form-group">
            <label htmlFor="poolZone">Pool Zone</label>
            <AsyncCreatable
              id="poolZone"
              classNamePrefix="selectPoolZoneInput"
              placeholder={this.state.poolZone}
              cacheOptions
              noOptionsMessage={() => null}
              isDisabled={this.state.poolInfoEditMode === false ? "disabled" : ""}
              onChange={(selected) => this.setState({ poolZone: selected.value })}
              value={{ label: this.state.poolZone, value: this.state.poolZone }}
              loadOptions={this.getPoolZoneOptions.bind(this)}
            />
          </div>
        </form>
      </div>
    );
  }
}

PoolInfo.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  poolName: PropTypes.string.isRequired,
  timeZone: PropTypes.string,
  poolZone: PropTypes.string,
  partnerSubscriptionId: PropTypes.string,
  partnerId: PropTypes.string,
  updatePool: PropTypes.func.isRequired,
  poolId: PropTypes.string,
  tenant: PropTypes.string,
  timeZones: PropTypes.arrayOf(PropTypes.string),
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isLoading: state.rdsPartners.isLoading,
    isSaving: state.poolAddEdit.isSaving,
    error: state.poolAddEdit.error,
    timeZones: state.system.timeZones,
    poolName: state.poolDetails.poolName,
    timeZone: state.poolDetails.timeZone,
    poolZone: state.poolDetails.poolZone,
    poolId: props.id,
    partnerSubscriptionId: state.poolDetails.partnerSubscriptionId,
    partnerId: state.poolDetails.partnerId,
    tenant: state.system.tenant,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePool,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PoolInfo);



// WEBPACK FOOTER //
// ./src/containers/pools/details/info/index.js